var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-white active",attrs:{"href":"#"},on:{"click":_vm.generateCSV}},[_c('i',{staticClass:"fas fa-file-csv"})])}
var staticRenderFns = []

export { render, staticRenderFns }